import { ReactElement } from 'react'
import { useFormState } from 'react-hook-form'
import { FormDirtyBlocker } from '@editorComponents'
import { PlanSettingsFormValues } from './utils'

interface Props {
  elementGuid: string
}

const PlanSettingsDirtyBlocker = ({ elementGuid }: Props): ReactElement | null => {
  const { isDirty } = useFormState<PlanSettingsFormValues>()

  return <FormDirtyBlocker actionId={`element-settings-${elementGuid}`} isDirty={isDirty} />
}

export default PlanSettingsDirtyBlocker
